var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonWorkDocsSdk32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-WorkDocs-SDK_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-WorkDocs-SDK_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-WorkDocs",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9574787,25.4907454 L15.957979,25.4907454 L15.957979,22.4892446 L14.9574787,22.4892446 L14.9574787,25.4907454 Z M7.50275138,15.9369685 L10.5042521,15.9369685 L10.5042521,14.9364682 L7.50275138,14.9364682 L7.50275138,15.9369685 Z M14.9574787,20.4882441 L15.957979,20.4882441 L15.957979,17.4867434 L14.9574787,17.4867434 L14.9574787,20.4882441 Z M15.957979,28.9994997 L15.957979,27.4917459 L14.9574787,27.4917459 L14.9574787,28.9994997 L3.00050025,28.9994997 L3.00050025,15.9369685 L5.50175088,15.9369685 L5.50175088,14.9364682 L3.00050025,14.9364682 L3.00050025,3.00050025 L14.9574787,3.00050025 L14.9574787,14.9364682 L12.5052526,14.9364682 L12.5052526,15.9369685 L15.4577289,15.9369685 L28.9994997,15.9369685 L28.9994997,28.9994997 L15.957979,28.9994997 Z M15.957979,3.64082041 L28.2191096,14.9364682 L15.957979,14.9364682 L15.957979,3.64082041 Z M30,15.4367184 C30,15.3006503 29.9429715,15.1665833 29.8389195,15.0695348 L15.7968984,2.13206603 C15.7018509,2.04502251 15.5807904,2 15.4577289,2 L2.50025013,2 C2.22311156,2 2,2.22311156 2,2.50025013 L2,29.4997499 C2,29.7768884 2.22311156,30 2.50025013,30 L29.4997499,30 C29.7758879,30 30,29.7768884 30,29.4997499 L30,15.4367184 Z",
    id: "Amazon-WorkDocs_Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonWorkDocsSdk32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-WorkDocs-SDK_32.530bc00b2903bb833d6214d616c6a0a0.svg";
export { ForwardRef as ReactComponent };